import React from 'react';
import {SidePanel} from 'routes/App/cashback/styles';

const GrowthTipsPanel = () => {
  return (
    <SidePanel>
      <h4 className='panelTitle'>Get more out of your cashback program</h4>
      <ul>
        <li>
          <b>Post on Instagram or Facebook</b> — let your regulars know they
          earn rewards on every online order
        </li>
        <li>
          <b>Share a story:</b> &ldquo;You might have cashback waiting — order
          now and use it!&rdquo;
        </li>
        <li>
          <b>Mention it</b> in your social media bio or link in bio
        </li>
        <li>
          <b>Attach a flyer</b> to order bags so customers learn about it at
          delivery
        </li>
      </ul>
    </SidePanel>
  );
};

export default GrowthTipsPanel;
